exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-bd984 .ant-select-selector{font-size:16px !important}", ""]);

// Exports
exports.locals = {
	"select": "select-bd984"
};